/**
 * @wordpress/data store name for the Harbor library.
 *
 * @package LiquidWeb\Harbor
 */
export const STORE_NAME = 'lw/harbor' as const;
